jQuery(function($){
   $('.js-nav-toggle').click(function(){
      // $('#mobile_menu').toggleClass('is-active');
      $('.js-nav-burger').toggleClass('is-active');
      $('#mobile_menu').toggle();
   })

   // main menu items which have children need to open on click rather than navigate to the page but the main page will be cloned as the first item
   // ie the menu item becomes a toggle for opening a sub menu
   $('.menu-item-has-children').each(function(el){

      // copy the element
      $subel = $(this).clone();

      //remove the sub-menu, leaving just the li and the child <a>
      $subel.children('.sub-menu').remove();

      // adjust the classes
      // ensure the current-menu-item class is added if it exists
      if($(this).hasClass('current-menu-item')){
         $subel.addClass('current-menu-item');
      }
      // dont include the parent class or this will be underlined
      if($(this).hasClass('current-menu-parent')){
         $subel.removeClass('current-menu-parent');
      }
      // remove this, it no longer has children
      $subel.removeClass('menu-item-has-children');

      // remove the id
      $subel.attr('id', '');
      // adjust the classes for the child a
      $subel.children('a').removeClass('main-menu-link');
      $subel.children('a').addClass('sub-menu-link');

      // add it as the first item in the immediate sub-menu
      $(this).children('.sub-menu').prepend($subel);
   });

   // add an icon as part of the link html to indicate a submenu
   $('.menu-item-has-children > a').each(function(i){
      $html = $(this).html();
      $(this).html( $html + '<span class="sub-menu-icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="30 40 40 20"><path class="icon-sub-menu" d="M50,59.5c-0.6,0-1.1-0.2-1.6-0.6l-17-14c-1.1-0.9-1.2-2.5-0.3-3.5c0.9-1.1,2.5-1.2,3.5-0.3L50,53.8l15.5-12.7  c1.1-0.9,2.6-0.7,3.5,0.3c0.9,1.1,0.7,2.6-0.3,3.5l-17,14C51.1,59.3,50.5,59.5,50,59.5z"/></svg></span>');
   });

   // when a top level menu link is clicked, toggle the submenu - this is for mobile
   $('.menu-item-has-children > a').on('click', function(e){
      e.preventDefault();
      $submenu = $(this).next('.sub-menu');
      $('.sub-menu').not($submenu).removeClass('is-visible');
      $submenu.toggleClass('is-visible');
   });

   $(document).on('click', function(event){
      if (!$(event.target).closest('.menu-item-has-children > a').length) {
         $('.sub-menu').removeClass('is-visible');
      }
  });

   // event read more
   $('.event-read-more button').click(function(){
      $(this).parent().toggleClass('more-open');
      $(this).parents('.event-details').children('.event-more-details').toggleClass('hidden');
   });

   // resize and position the featured image on single page
   window.addEventListener('resize', function(){
      resizeSingleFeaturedImage();
   });

   $('.single-featured-image').on('resize', null, null, function(){
      console.log('hello');
   });
   $('.single-featured-image').resize(function(){
      console.log('sizy');
   });
   $('.single-featured-image').on('click', null, null, function(){
      console.log('clicky');
   });

   // the featured image needs to break out of the .container and be right aligned but also resize properly
   // with the browser width. This will find the widths of the container me
   function resizeSingleFeaturedImage(){
      if(window.innerWidth > 781 && window.innerWidth < 1440) {
         let mainContainer = document.getElementById('single_header_container');
         if (mainContainer) {
            let mainContainerStyle = window.getComputedStyle(mainContainer);
            let imgContainer = document.getElementById('single_featured_image_container');
            let imgContainerStyle = window.getComputedStyle(imgContainer);

            // combine the right hand margin with the width of the container
            let imgWidth = parseInt(mainContainerStyle.marginRight) + parseInt(imgContainerStyle.width);

            $('.single-featured-image').css({
               position: 'absolute',
               right: 0,
               width: `${imgWidth}px`,
               top: mainContainerStyle.paddingTop,
            });

            let featuredImage = document.getElementById('single_featured_image');
            let featuredImgSyle = window.getComputedStyle(featuredImage);
            $('#header_details').css({
               minHeight: featuredImgSyle.height
            });
         }

      } else {
         // reset
         $('.single-featured-image').css({
            position: 'relative',
            right: 0,
            width: `100%`,
         });
         $('#header_details').css({
            minHeight: 'unset',
         });
      }
   }

   if($('#single_featured_image_container')){
      resizeSingleFeaturedImage();
   }

   // highlight news current menu item when on single template
   // for some reason wp is not doing this for us
   let locationBits = window.location.pathname.split('/');
   if(locationBits[1] === 'news') {
      $('.news-link').addClass('current-menu-item');
   }
   // add area map active class
   if(locationBits[1] === 'area-map') {
      $('#area_map_nav').addClass('active');
   }





   // mailchimp

   function validate_email(email){
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.exec(email);
   }

   $('.subscribe-module form').on('submit', function(e) {
      e.preventDefault();

      var theForm = this;
      var email = this.subscriber_email.value;
      var feedback_div = this.parentNode.querySelector('.feedback');

      if(!validate_email(email)){
         feedback_div.innerHTML='<p>Please check your email address and try again</p>';
         feedback_div.style.display='block';
         return false;
      }

      var data = $(this).serialize();

      $.ajax({
         type: "POST",
         url: local_vars.ajaxurl,
         data: data,
         beforeSend: function(){
            // Handle the beforeSend event
            feedback_div.style.display = 'block';
            feedback_div.innerHTML = '<p>Loading, please wait</p>';
         },
         success: function(res) {
            var response = JSON.parse(res);

            //update the feedback
            feedback_div.style.display = 'block';
            feedback_div.innerHTML = response.message;

            //reset the form
            theForm.reset();
         },
         fail: function(jqXHR, textStatus){
            feedback_div.style.display = 'block';
            feedback_div.innerHTML = '<p>Something went wrong, sorry!</p>';
         },
         complete: function(){
            // maybe turn a loading spinner off or something...
         }
      });
   });

   //signup form, reset error message on email click
   $('.subscribe-module .subscriber_email').click(function(){
      $(this).parent('.newsletter-signup').find('.feedback').fadeOut();
   });

});
